import './NavUnresolved.css';

export interface NavUnresolvedProps {
  /** The server's own sentence about why the rail did not resolve. */
  failure: string;
  /** Present only when asking again could change the answer — a permanent
   *  refusal gets the sentence and nothing to press. */
  onRetry?: () => void;
}

/**
 * WHAT A SHELL WITH NO TABS SAYS.
 *
 * Until 2026-09-01 the answer was DEFAULT_NAV_DESTINATIONS — the July Actor
 * rail, Today · Auditions · Projects · Career — which every CallToWrap load
 * showed before `GET /api/team/me` answered, and forever if it never did. A
 * household saw another pack's tabs and had no way to know they were wrong.
 *
 * So the rail is now empty while the answer is unknown, and this is how the
 * empty says why. The server's own sentence, verbatim; a way to ask again
 * only when asking again could change the answer.
 */
export function NavUnresolved({ failure, onRetry }: NavUnresolvedProps) {
  return (
    <div class="nav-unresolved" role="status">
      <span>This workspace’s tabs didn’t load — {failure}</span>
      {onRetry ? (
        <button type="button" class="nav-unresolved__retry" onClick={onRetry}>
          Ask again
        </button>
      ) : null}
    </div>
  );
}
